import React from "react";
import AddAndUpdateSchool from "./Add&UpdateSchoolForm";

const UpdateSchool = () => {
  return <AddAndUpdateSchool isUpdate={true} />;
};

export default UpdateSchool;
